module.exports = __webpack_public_path__ + "img/profile.b95cbd4a.jpg";